import Vue from 'vue';
import VueRouter from 'vue-router';

import Dashboard from '@/views/tableau-de-bord';
import AdminDashboard from '@/views/tableau-de-bord/dashboard-admin';
import InfirmierDashboard from '@/views/tableau-de-bord/dashboard-infirmier';
import LaboratinDashboard from '@/views/tableau-de-bord/dashboard-laboratin';
import MedecinDashboard from '@/views/tableau-de-bord/dashboard-medecin';

import AddPatient from '@/views/addPatient';
import Patients from '@/views/listePatient';
import PatientInfo from '@/views/patientInfo';

import AjouterAnalyse from '@/views/creerAnalyse';
import ListeAnalyse from '@/views/listeAnalyse';
import ListeModelesAnalyse from '@/views/modeles-analyses/liste';
// import CreerModeleAnalyse from '@/views/modeles-analyses/creer';
// import ModifierModeleAnalyse from '@/views/modeles-analyses/modifier';

import CreerModifierModeleAnalyse from '@/views/modeles-analyses/editer';

import SaisieResultasAnalyse from '@/views/analyse/resultats-analyses/saisie-resultats';

import RegistreOthers from '@/views/analyse/others-registre';
import RegistreBiochimie from '@/views/analyse/registre-biochimie';
import RegistreCRP from '@/views/analyse/registre-crp';
import RegistreGE from '@/views/analyse/registre-ge';
import RegistreNFS from '@/views/analyse/registre-nfs';
import ResultatBiochimie from '@/views/analyse/resultat-biochimie';
import ResultatCRP from '@/views/analyse/resultat-crp';
import ResultatGE from '@/views/analyse/resultat-ge';
import ResultatNFS from '@/views/analyse/resultat-nfs';
import EditerAnalyse from '@/views/editerAnalyse';

import store from '@/store';
import ResultatTDR from '@/views/analyse/resultat-tdr';
import CreerDossier from '@/views/dossierMedical/create';
import Login from '@/views/login';
// >>>>>>>> Consultations
import SalleAttente from '@/views/consultations/salle-attente';

// ========================================>Medecine Du Travail<==============================
// SOCIETE
import CreerSociete from '@/views/mdt/societe/creerSociete';
import ListeSociete from '@/views/mdt/societe/listeSociete';
import SocieteDetails from '@/views/mdt/societe/societeDetails';

import AccidentMaladie from '@/views/mdt/accidents-maladies-pro/accident-maladie-pro';
import Certificats from '@/views/mdt/certificats';
import DocumentUnique from '@/views/mdt/document-unique';
import Facturation from '@/views/mdt/facturations/facturations';
import Rapport from '@/views/mdt/rapports/rapports';
import TravailleurInfo from '@/views/mdt/travailleurs/travailleur-info';
import CategorieVisiteMedicale from '@/views/mdt/visite-medicales/categories';
import VisiteMedicaleListWrapper from '@/views/mdt/visite-medicales/categories/category-wrapper';
import ParamVisiteMedicale from '@/views/mdt/visite-medicales/parametrages-globaux';
import VisiteMedicale from '@/views/mdt/visite-medicales/visite-medicales';
import VisitePoste from '@/views/mdt/visite-postes/visite-postes';
// ========================================>Medecine Du Travail<==============================

// ===============          PARAMETRES          ==============
import Parametres from '@/views/parametres';
import AccesConsultations from '@/views/parametres/accessibilites/acces-consultations';
import AccesExamens from '@/views/parametres/accessibilites/acces-examens';
import Assurances from '@/views/parametres/assurances';
import AssuranceGroupeList from '@/views/parametres/assurances/assurance-groupe-list';
import AssuranceGroupes from '@/views/parametres/assurances/assurance-groupes';
import ListeSouscripteurs from '@/views/parametres/assurances/liste-assures';
import Souscripteur from '@/views/parametres/assurances/liste-assures/assure-detail';
import AssureurDetail from '@/views/parametres/assurances/liste-assures/assureur-detail';
import Champ from '@/views/parametres/champs';
import ChampSpecialite from '@/views/parametres/champs/champ-specialite';
import ParamExamensCliniques from '@/views/parametres/examens-cliniques';
import TarificationCatOnmt from '@/views/parametres/tarifications';

import PendingResultVisitesMedicales from '@/views/analyse/pending-visites-medicales';
import Resultats from '@/views/analyse/pending-visites-medicales/resultats';
import TarifActes from '@/views/parametres/tarif-actes';
import TarifAdmissions from '@/views/parametres/tarif-admissions';

import RegistreAnalyse from '@/views/analyse/registre_analyse';
import StatDiagnostiques from '@/views/consultations/statistique-diagnostiques';
import PorterResultatExamen from '@/views/examens';
import RegistreExamen from '@/views/examens/registre';
import SalleExamen from '@/views/examens/salle-examen';

import BlockedUI from '@/components/blocked-ui';
import Configs from '@/views/parametres/configs';
import Profil from '@/views/parametres/profil';


Vue.use(VueRouter)

const routes = [
    {
        path: '/blocked',
        name: 'Access Denied',
        component: BlockedUI,
    },

    {
        path: '/',
        name: 'Index',
        redirect: '/dashboard'
    },
    {
        path: '/dashboard',
        name: 'Tableau de bord',
        component: Dashboard,
    },
    {
        path: '/dashboard-admin',
        name: 'Administrateur',
        component: AdminDashboard,
    },
    {
        path: '/dashboard-admin',
        name: 'Infirmier',
        component: InfirmierDashboard,
    },
    {
        path: '/dashboard-admin',
        name: 'Medecin',
        component: MedecinDashboard,
    },
    {
        path: '/dashboard-admin',
        name: 'Laboratin',
        component: LaboratinDashboard,
    },
    {
        path: '/dashboard/salle-attente',
        name: 'Salle d\'attente',
        component: SalleAttente,
    },
    {
        path: '/patients/ajouter/:patient_id',
        name: 'AjouterPatient',
        component: AddPatient
    },
    {
        path: '/patients',
        name: 'liste-patients',
        component: Patients
    },
    {
        path: '/patients/:id/:consultation',
        name: 'patientInfo',
        component: PatientInfo,
        props: true,
        children: [{
                path: '/resultat-nfs/:resultat_id',
                name: 'ResultatNFS',
                component: ResultatNFS

            },
            {
                path: '/resultat-crp/:resultat_id',
                name: 'ResultatCRP',
                component: ResultatCRP

            },
            {
                path: '/resultat-ge/:resultat_id',
                name: 'ResultatGE',
                component: ResultatGE
            },
            {
                path: '/resultat-tdr/:resultat_id',
                name: 'ResultatTDR',
                component: ResultatTDR
            }
        ]
    },
    {
        path: '/analyses/ajouter',
        name: 'creerAnalyse',
        component: AjouterAnalyse
    },
    {
        path: '/parametres/champs',
        name: 'Champs',
        component: Champ
    },
    {
        path: '/parametres/champs/access-par-specialite',
        name: 'Accès Champ',
        component: ChampSpecialite
    },

    {
        path: '/parametres/accessibilite/consultations',
        name: 'Accès Consultations',
        component: AccesConsultations
    },
    {
        path: '/parametres/accessibilite/examens',
        name: 'Accès Examens',
        component: AccesExamens
    },

    {
        path: '/parametres/analyses',
        name: 'listeAnalyse',
        component: ListeAnalyse
    },
    
    {
        path: '/parametres/modeles-analyses',
        name: 'listeModelesAnalyse',
        component: ListeModelesAnalyse,
    },

    {
        path: '/parametres/modeles-analyses/:id(\\d+)?/:action(creer|editer)',
        name: 'creerModifierModeleAnalyse',
        component: CreerModifierModeleAnalyse,
    },

    {
        path: '/analyses/:analyseId/patients/:patientId/resultats',
        name: 'saisie-resultats-analyse',
        component: SaisieResultasAnalyse
    },

    {
        path: '/analyses/editer/:id',
        name: 'editerAnalyse',
        component: EditerAnalyse
    },
    {
        path: '/analyses/registre-nfs',
        name: 'Registre NFS',
        component: RegistreNFS
    },
    {
        path: '/analyses/analyse-nfs/:resultat_id',
        name: 'TSLResultatNFS',
        component: ResultatNFS
    },
    {
        path: '/analyses/registre-crp',
        name: 'Registre CRP',
        component: RegistreCRP
    },
    {
        path: '/analyses/registre-others/:analyse_id',
        name: 'Registre others',
        component: RegistreOthers
    },
    {
        path: '/analyses/analyse-crp/:resultat_id',
        name: 'TSLResultatCRP',
        component: ResultatCRP
    },
    {
        path: '/analyses/registre-ge',
        name: 'Registre GE',
        component: RegistreGE
    },
    {
        path: '/analyses/analyse-ge/:resultat_id',
        name: 'TSLResultatGE',
        component: ResultatGE
    },
    {
        path: '/analyses/registre-biochimie',
        name: 'Registre Biochimie',
        component: RegistreBiochimie
    },
    {
        path: '/analyses/resultat-biochimie',
        name: 'Resultat Biochimie',
        component: ResultatBiochimie
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/patients/:id/creer-dossier-medical',
        name: 'dossier_create',
        component: CreerDossier
    },

    {
        path: '/examens/registre',
        name: 'Registre examen',
        component: RegistreExamen
    },
    {
        path: '/examens/salle-examen/:examen_id',
        name: 'Salle examen',
        component: SalleExamen
    },

    {
        path: '/examens/porter-resultat',
        name: 'Porter résultat',
        component: PorterResultatExamen
    },

    {
        path: '/registre/analyses',
        name: 'Registre Analyse',
        component: RegistreAnalyse
    },
    // +++++++++++++        MEDECINE DU TRAVAIL     +++++++++++++++
    // {
    //     path: '/societes',
    //     name: 'Societe',
    //     component: Societe
    // },
    {
        path: '/facturations',
        name: 'Facturation',
        component: Facturation
    },
    {
        path: '/visites-de-postes',
        name: 'VisitePoste',
        component: VisitePoste
    },
    {
        path: '/visite-medicales/resultats/pending',
        name: 'VisiteMedicalePendingResult',
        component: PendingResultVisitesMedicales
    },
    {
        path: '/visite-medicales/resultats/pending/:id',
        name: 'VisiteMedicalePendingResultList',
        component: Resultats
    },
    {
        path: '/visite-medicales',
        name: 'VisiteMedicale',
        component: VisiteMedicale
    },
    {
        path: '/visite-medicales/parametrages',
        name: 'ParamVisiteMedicale',
        component: ParamVisiteMedicale
    },
    {
        path: '/visite-medicales/categories',
        name: 'categorieVisiteMedicale',
        component: CategorieVisiteMedicale
    },
    {
        path: '/visite-medicales/categories/:id',
        name: 'categorieVisiteMedicaleItems',
        component: VisiteMedicaleListWrapper
    },
    {
        path: '/accident-maladie-pro',
        name: 'AccidentMaladie',
        component: AccidentMaladie
    },
    {
        path: '/rapports',
        name: 'Rapport',
        component: Rapport
    },
    {
        path: '/certificats',
        name: 'Certificats',
        component: Certificats
    },
    {
        path: '/document-unique',
        name: 'DocumentUnique',
        component: DocumentUnique
    },

    {
        path: '/societes',
        name: 'liste_societes',
        component: ListeSociete
    },
    {
        path: '/societes/creer-societe',
        name: 'creer_societes',
        component: CreerSociete
    },
    {
        path: '/societes/:id',
        name: 'profilSociete',
        component: SocieteDetails
    },
    {
        path: '/societes/:id/:params',
        name: 'Parametrage_Societe',
        component: SocieteDetails
    },
    {
        path: '/societes/:id/:travailleurs',
        name: 'profilSocieteSections',
        component: SocieteDetails
    },
    {
        path: '/analyses/analyse-tdr/:resultat_id',
        name: 'TSLResultatTDR',
        component: ResultatTDR
    },
    {
        path: '/travailleur/:travailleur_id',
        name: 'TravailleurInfo',
        component: TravailleurInfo
    },

    // +++++++++    Paramètres      ++++++++++++
    {
        path: '/parametres',
        name: 'Parametres',
        component: Parametres
    },
    {
        path: '/parametres/assurances',
        name: 'Assurances',
        component: Assurances
    },
    {
        path: '/parametres/assurances/groupe/:id',
        name: 'Groupe Assurance',
        component: AssuranceGroupes,
    },
    {
        path: '/parametres/groupe-assurance',
        name: 'Groupe Assurance',
        component: AssuranceGroupeList,
    },
    {
        path: '/parametres/assureur/:id',
        name: 'Assureur',
        component: ListeSouscripteurs
    },
    {
        path: '/parametres/assureur/:id/souscripteur/:assure_id',
        name: 'Souscripteur',
        component: Souscripteur
    },
    {
        path: '/parametres/assureur/:id/detail/souscripteur/:assure_id',
        name: 'Souscripteur',
        component: AssureurDetail
    },

    // >>>>>>>>>        PARAM Tarification 
    {
        path: '/parametres/tarification-cat-onmt',
        name: 'TarificationCatOnmt',
        component: TarificationCatOnmt
    },
    {
        path: '/parametres/examens-cliniques',
        name: 'ExamensCliniquesParam',
        component: ParamExamensCliniques
    },
    {
        path: '/parametres/tarif-admissions',
        name: 'TarifAdmissions',
        component: TarifAdmissions
    },
    {
        path: '/parametres/tarif/acte-soins',
        name: 'TarifActes',
        component: TarifActes
    },

    // STATS DIAGNOSTICS
    {
        path: '/dashboard/statistiques-sante',
        name: 'Statistique Santé',
        component: StatDiagnostiques
    },

    {
        path: '/parametres/configs',
        name: 'Configurations',
        component: Configs
    },

    {
        path: '/parametres/profil',
        name: 'Profil',
        component: Profil
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    let access = false;
    let role;
    let role_actif
    if (store.getters['authInfo']) {
        role = store.getters['authInfo'].roles
        access = false
        for (let index = 0; index < role.length; index++) {
            if (
                role[index].nom == "ROLE_INFIRMIER" || role[index].nom == "ROLE_MEDECIN" ||
                role[index].nom == "ROLE_ADMINISTRATEUR" || role[index].nom == "ROLE_TECH_SUP_LABO" ||
                role[index].nom == "ROLE_MEDECIN_TRAVAIL" || role[index].nom == "ROLE_SAGE_FEMME" || 
                role[index].nom == "ROLE_INFIRMIER_MEDECINE_TRAVAIL" || role[index].nom == "ROLE_TECHNICIEN_IMAGERIE"
            ) {
                if (store.getters['activeRole']) {
                    role_actif = store.getters['activeRole'].nom
                    if (
                        role_actif != 'ROLE_INFIRMIER' && role_actif != 'ROLE_MEDECIN' && role_actif != 'ROLE_TECH_SUP_LABO' &&
                        role_actif != 'ROLE_ADMINISTRATEUR' && role_actif != 'ROLE_MEDECIN_TRAVAIL' && 
                        role_actif != 'ROLE_SAGE_FEMME' && role_actif != 'ROLE_INFIRMIER_MEDECINE_TRAVAIL' && role_actif != 'ROLE_TECHNICIEN_IMAGERIE'
                    ) {
                        if (role[index].pivot.is_active != true || role[index].pivot.is_active != '1' || role[index].pivot.is_active != 1) {
                            store.dispatch('switchRole', { userId: store.getters['authInfo'].id, roleId: role[index].pivot.role_id })
                        }
                    }
                } else {
                    if (role[index].pivot.is_default == 1) {
                        store.dispatch('switchRole', { userId: store.getters['authInfo'].id, roleId: role[index].pivot.role_id })
                    }
                }
                
                access = true
                break;
            } else
                access = false
        }
    }


    if (!store.getters['authInfo'] && to.name != 'login') {
        localStorage.clear();
        router.push('/login')
    } else if (access === false && to.name != 'login') {
        localStorage.clear();
        router.push('/login')
    } else {
        // const user_info = store.getters['authInfo']
        
        // const can_login = user_info?.can_login
        
        // next()
        // if (can_login == null || can_login == 0) {
        //     localStorage.clear();
        //     router.push('/login')
        // } else {
        //     let countdown = {}
        //     store.dispatch('getCountDown').then((response) => {
        //         countdown = response
        //         if (countdown.is_count == 1 && countdown.duree_restant.days < 0) {
        //             router.push('/blocked')
        //         } 
        //     })
        // }

        next()
        // let countdown = {}
        // store.dispatch('getCountDown').then((response) => {
        //     countdown = response
        //     console.log("next to ",countdown);
        //     if (countdown.is_count == 1 && countdown.duree_restant.days < 0) {
        //         router.push('/blocked')
        //     } 
        // })
    }

})


export default router